import styled from "styled-components"
import { device } from "../../constants/breakpoints"

export const Container = styled.div`
  padding-top: 20px;
  padding-bottom: 60px;
  display: flex;
  flex-direction: row;
  background: #fafafa;
  @media ${device.tablet} {
    padding-top: 5px;
    flex-direction: column;
  }
`

export const TabletCardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media ${device.laptop} {
    justify-content: center;
  }
`

export const MobileCardsContainer = styled.div`
  margin-top: 30px;
`

export const CardsContainer = styled.div`
  @media ${device.tablet} {
    display: none;
  }
`

export const NoDesktop = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`

export const NoMobile = styled.div`
  @media ${device.tablet} {
    display: none;
  }
`

export const CardsTitle = styled.p`
  color: ${({ theme }) => theme.blackblue};
  font-size: 28px;
  font-weight: 600;
  margin: 50px;
  margin-top: 3px;
  text-align: center;
`

export const CardsSubTitle = styled.p`
  color: ${({ theme }) => theme.lightblue};
  font-size: 22px;
  text-align: center;
  margin-bottom: 0;
`
